<app-breadcrumb [title]="'Transfer Order'"></app-breadcrumb>

<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">

        <div class="card-body">


          <div class="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom">
            <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
            <a [routerLink]="['/management/transfer-orders']" class="btn btn-outline-primary">Cancel</a>
          </div>

          <app-loader [show]="skeleton"></app-loader>
          <div [class.d-none]="skeleton">


            <div *ngIf="profile">
              <dl class="row">
                <dt class="col-sm-3">Name</dt>
                <dd class="col-sm-9">{{ profile.firstName + ' ' + profile.middleName + ' ' + profile.lastName }}
                </dd>
              </dl>
            </div>

            <form [formGroup]="transferOrderForm" (ngSubmit)="save()">
              <input type="hidden" formControlName="id">
              <input type="hidden" formControlName="profileId">

              <div class="border rounded p-3 mb-3">
                <div class="row">
                  <div class="col-md-12">
                    <h4>From School/Place</h4>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="fromSchoolLevelId">Department</label>
                      <select MyInput formControlName="fromSchoolLevelId" class="form-select form-select-sm"
                        (change)="changeDepartment($event.target.value)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of schoolLevels" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="fromSchoolLevelId" errorKey="required">Department is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3" *ngIf="transferOrderForm.get('fromSchoolLevelId').value == 1">
                      <label class="form-label" for="fromRegionId">Region</label>
                      <select MyInput formControlName="fromRegionId" class="form-select form-select-sm"
                        (change)="getStates($event.target.value)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of regions" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="fromRegionId" errorKey="required">Region is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3" *ngIf="transferOrderForm.get('fromSchoolLevelId').value == 1">
                      <label class="form-label" for="fromStateId">State</label>
                      <select MyInput formControlName="fromStateId" class="form-select form-select-sm"
                        (change)="getDistricts($event.target.value)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of fromStates" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="fromStateId" errorKey="required">State is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3" *ngIf="transferOrderForm.get('fromSchoolLevelId').value == 1">
                      <label class="form-label" for="fromDistrictId">District</label>
                      <select MyInput formControlName="fromDistrictId" class="form-select form-select-sm"
                        (change)="getSchools($event.target.value)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of fromDistricts" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="fromDistrictId" errorKey="required">District is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="fromSchoolId">School</label>
                      <select MyInput formControlName="fromSchoolId" class="form-select form-select-sm">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of fromSchools" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="fromSchoolId" errorKey="required">School is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="fromDesignationId">Designation</label>
                      <select MyInput formControlName="fromDesignationId" class="form-select form-select-sm">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of designations" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="fromDesignationId" errorKey="required">Designation is required.</my-error>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <h4>To School/Place</h4>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="toSchoolLevelId">Department</label>
                      <select MyInput formControlName="toSchoolLevelId" class="form-select form-select-sm"
                        (change)="changeDepartment($event.target.value, true)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of schoolLevels" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="toSchoolLevelId" errorKey="required">Department is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3" *ngIf="transferOrderForm.get('toSchoolLevelId').value == 1">
                      <label class="form-label" for="toRegionId">Region</label>
                      <select MyInput formControlName="toRegionId" class="form-select form-select-sm"
                        (change)="getStates($event.target.value, true)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of regions" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="toRegionId" errorKey="required">Region is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3" *ngIf="transferOrderForm.get('toSchoolLevelId').value == 1">
                      <label class="form-label" for="toStateId">State</label>
                      <select MyInput formControlName="toStateId" class="form-select form-select-sm"
                        (change)="getDistricts($event.target.value, true)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of toStates" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="toStateId" errorKey="required">State is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3" *ngIf="transferOrderForm.get('toSchoolLevelId').value == 1">
                      <label class="form-label" for="toDistrictId">District</label>
                      <select MyInput formControlName="toDistrictId" class="form-select form-select-sm"
                        (change)="getSchools($event.target.value, null, true)">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of toDistricts" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="toDistrictId" errorKey="required">District is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="toSchoolId">School</label>
                      <select MyInput formControlName="toSchoolId" class="form-select form-select-sm">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of toSchools" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="toSchoolId" errorKey="required">School is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="toDesignationId">Designation</label>
                      <select MyInput formControlName="toDesignationId" class="form-select form-select-sm">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of designations" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="toDesignationId" errorKey="required">Designation is required.</my-error>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="orderNo">Order No</label>
                      <input MyInput formControlName="orderNo" class="form-control form-control-sm" />
                      <my-error controlName="orderNo" errorKey="required">Order No is required.</my-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="orderDate">Order Date</label>
                      <div class="input-group">
                        <span class="input-group-text">
                          <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                        </span>
                        <input MyInput formControlName="orderDate" placeholder="dd-mm-yyyy"
                          class="form-control form-control-sm datepicker"
                          [minDate]="{year: year - 60, month: 1, day: 1}" [maxDate]="{year: year, month: 12, day: 31}"
                          ngbDatepicker #orderDate="ngbDatepicker" (click)="orderDate.toggle()" />
                      </div>
                      <my-error controlName="orderDate" errorKey="required">Order Date is required.</my-error>
                      <my-error controlName="orderDate" errorKey="pattern">Order Date pattern invalid.</my-error>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group mb-3">
                      <label class="form-label" for="transferCategoryId">Transfer Category</label>
                      <select MyInput formControlName="transferCategoryId" class="form-select form-select-sm">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of transferCategories" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                      <my-error controlName="transferCategoryId" errorKey="required">Transfer Category is required.
                      </my-error>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group mb-3">
                      <label for="remark">Remark 1</label>
                      <div class="col-md-12 px-0">
                        <textarea class="form-control" formControlName="remark" rows="2"></textarea>
                      </div>
                      <my-error controlName="remark" errorKey="required">Remark is required.</my-error>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group mb-3">
                      <label for="remark1">Remark 2</label>
                      <div class="col-md-12 px-0">
                        <textarea class="form-control" formControlName="remark1" rows="2"></textarea>
                      </div>
                      <my-error controlName="remark1" errorKey="required">Remark 2 is required.</my-error>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group mb-3 form-check">
                      <input type="checkbox" MyInput formControlName="cumulativeCountAdd" class="form-check-input"
                        id="cumulativeCountAdd">
                      <label class="form-label" for="cumulativeCountAdd">Cumulative Count Addition</label>
                    </div>
                    <my-error controlName="cumulativeCountAdd" errorKey="required">Cumulative Count Addition is
                      required.</my-error>
                  </div>


                  <div class="col-md-12">
                    <div class="form-group mb-3 form-check">
                      <input type="checkbox" MyInput formControlName="cumulativeCountPrev" class="form-check-input"
                        id="cumulativeCountPrev">
                      <label class="form-label" for="cumulativeCountPrev">Cumulative Count Previous</label>
                    </div>
                    <my-error controlName="cumulativeCountPrev" errorKey="required">Cumulative Count Previous is
                      required.</my-error>
                  </div>
                </div>
              </div>

              <div class="d-flex">
                <button class="btn btn-primary rounded-0 ml-auto mr-2" [disabled]="!transferOrderForm.valid || loading"
                  type="submit">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="loading"></span>
                  Submit
                </button>
                <button *ngIf="id" type="button" (click)="delete()" class="btn btn-danger rounded-0">Delete</button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>